<template>
  <section v-if="roomsList?.length" :id="data?.anchor_id ? data.anchor_id : null" class="accommodationUnit defaultSectionPaddings">
    <div class="container">
      <div class="accommodationUnit__Heading">
        <h2 v-text="data.title" />
      </div>

      <FlickitySlider class="accommodationUnit__Flickity mediumArrows" :withProgress="true" :options="flickityOptions" customClass="accommodationUnit__SliderInner" :minNumberOfSlides="3">
        <div v-for="item in roomsList" class="accommodationUnit__Item">
          <div class="accommodationUnit__Image">
            <Flare v-if="item.details.images.length" :srcset="{ meta: item.details.images[0] }" size="both" width="420" height="315" crop="fill" />
            <Button
              v-if="availableDates && Object.keys(availableDates).length"
              medium
              secondary
              negative
              prevent
              type="nuxt-link"
              :to="{ path: link('AccommodationUnitList'), query: { accommodation_id: page.id, room_id: item.external_id } }"
              rel="nofollow"
              @click.native.prevent="handleRoomsListingClick($event, { path: link('AccommodationUnitList'), query: { accommodation_id: page.id, room_id: item.external_id } })"
            >
              {{ $t('checkRates') }}
            </Button>
          </div>
          <div class="accommodationUnit__Content">
            <h3 v-text="item.details.name" />
            <p>
              {{ formatPrice(item.price.amount, item.price.currency, lang, true) }}
              {{ $t(`prices.${formatStayTextId(item.price.price_type)}`).toLowerCase() }}<template v-if="item.price?.board && item.price.board !== 'None'">, {{ $t(`checkoutPricelistKinds.${item.price.board.toLowerCase()}`) }}</template>
            </p>
          </div>
        </div>
      </FlickitySlider>

      <div class="accommodationUnit__LoadAll">
        <Button
          v-if="availableDates && Object.keys(availableDates).length"
          type="nuxt-link"
          :to="{ path: link('AccommodationUnitList'), query: { accommodation_id: page.id } }"
          secondary
          medium
          prevent
          class="accommodationUnit__LoadAllButton"
          rel="nofollow"
          @click.native.prevent="handleRoomsListingClick($event, { path: link('AccommodationUnitList'), query: { accommodation_id: page.id } })"
        >{{ $t('seeAll') }}</Button>
      </div>
    </div>

    <Loader :active="fetchingData"></Loader>
  </section>
</template>

<script setup>
  import { format, toZonedTime } from 'date-fns-tz';
  defineProps({
    data: {},
  });
  const { page } = usePage();
  const { lang } = useLanguage();
  const { link, accommodationsData } = useSetup();
  const { getAvailabilityDates, updateSearchDates } = useAvailabilityDates();
  const roomsList = ref([]);
  const fetchingData = ref(false);
  const availableDates = ref(null);

  async function fetchUnitData() {
    try {
      fetchingData.value = true;
      const currentAccommodation = accommodationsData.value[page.value.id];
      if (currentAccommodation) availableDates.value = getAvailabilityDates(currentAccommodation.availability_calendar);

      if ([null, undefined].includes(availableDates.value)) return;
      const response = await useClientFetch('search/unit/', {
        method: 'POST',
        body: {
          accommodation: page.value.id,
          adults_count: 2,
          date_from: format(toZonedTime(new Date(availableDates.value?.from), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' }),
          date_to: format(toZonedTime(new Date(availableDates.value?.to), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' }),
        }
      })

      if (response?.units?.length) roomsList.value = response.units;
    } catch(error) {
      console.log(error);
    } finally {
      fetchingData.value = false;
    }
  }

  async function handleRoomsListingClick(event, link) {
    await updateSearchDates(availableDates.value, true);
    await navigateTo(link);
  }
  
  fetchUnitData();

  const flickityOptions = {
    pageDots: false,
    cellAlign: 'left',
    contain: true,
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_accommodationUnit.scss');
</style>